import { Button } from "@/components/ui/Button";
import { Spinner } from "@/components/ui/Spinner";
import { currentYear, shiftYear } from "@/lib/auswertungen";

/** Jahresauswahl + Neu-laden im Stil der übrigen Auswertungen-Seiten. */
export function ReportYearPicker({
  year,
  onYearChange,
  loading,
  refreshing,
  onReload,
}: {
  year: number;
  onYearChange: (year: number) => void;
  loading?: boolean;
  refreshing?: boolean;
  onReload?: () => void;
}) {
  const isCurrentYear = year === currentYear();
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-separator text-lg text-label transition hover:border-accent hover:text-accent"
          aria-label="Vorheriges Jahr"
          onClick={() => onYearChange(shiftYear(year, -1))}
        >
          ‹
        </button>
        <div className="min-w-[5rem] text-center text-base font-semibold text-label">{year}</div>
        <button
          type="button"
          className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-separator text-lg text-label transition hover:border-accent hover:text-accent"
          aria-label="Nächstes Jahr"
          onClick={() => onYearChange(shiftYear(year, 1))}
        >
          ›
        </button>
        {!isCurrentYear ? (
          <Button
            type="button"
            variant="secondary"
            size="sm"
            className="h-8"
            onClick={() => onYearChange(currentYear())}
          >
            Aktuelles Jahr
          </Button>
        ) : null}
      </div>
      {onReload ? (
        <div className="flex items-center gap-2">
          {refreshing ? (
            <span className="flex items-center gap-1.5 text-xs text-label-secondary">
              <Spinner className="h-3.5 w-3.5" />
              wird aktualisiert …
            </span>
          ) : null}
          <Button variant="secondary" size="sm" onClick={onReload} loading={loading}>
            Neu laden
          </Button>
        </div>
      ) : null}
    </div>
  );
}
